import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { getProviderListNetworkAction } from "../../../../redux/actions/TestPackageNetworkAction";
import { getAdoptionAnalysisAction } from "../../../../redux/actions/NetworkIntelligenceAction";
import {
  AdoptionFunnelBox,
  callAdoptionAnalysisAction,
  initialExcelStateAdoption,
  initialStateAdoption,
  tableHeaderAnalysis,
} from "./helper";
import { SearchIcon } from "../../../../Utils/SvgIcons";
import { TableHeaderAdmin } from "../../HelloAdmin/helper";
import CommonDateRangePicker from "../../CommonComponent/CommonDateRangePicker";
import CustomPagination from "../../../../common/CustomPagination";
import { API_URL_WITHOUT_USER } from "../../../../Utils/API";
import { getNetworkMenuId, getToken } from "../../../../Utils/types";

const AdoptionAnalysis = () => {
  const dispatch = useDispatch();
  const [multiSelect, setMultiSelect] = useState([]);
  const [searchFilter, setSearchFilter] = useState(initialStateAdoption);
  const [selectAll, setSelectAll] = useState(false);
  const [isLoadingExcel, setIsLoadingExcel] = useState(false);

  const getAdoptionAnalysisDetails = useSelector(
    (state) => state?.NetworkIntelligenceReducer?.getAdoptionAnalysisDetails
  );

  const globalReducer = useSelector((state) => state.globalReducer);
  const TestPackageReducer = useSelector((state) => state?.TestPackageReducer);

  useEffect(() => {
    dispatch(getProviderListNetworkAction());
    callAdoptionAnalysisAction(dispatch, searchFilter);
  }, []);

  const handleSearch = () => {
    setSearchFilter({ ...searchFilter, page: 1 });
    callAdoptionAnalysisAction(dispatch, {
      ...searchFilter,
      ProviderIds: searchFilter?.ProviderIds?.toString(),
      page: 1,
    });
  };

  const handleClearFilter = () => {
    setSearchFilter(initialStateAdoption);
    setMultiSelect([]);
    setSelectAll(false);
    callAdoptionAnalysisAction(dispatch, initialStateAdoption);
  };

  const SortHandler = (sortColumnName, sortDirection) => {
    setSearchFilter({
      ...searchFilter,
      SortColumn: sortColumnName,
      sortDirection: sortDirection,
      page: 1,
    });
    callAdoptionAnalysisAction(dispatch, {
      ...searchFilter,
      SortColumn: sortColumnName,
      sortDirection: sortDirection,
      page: 1,
    });
  };

  const appointmentIds =
    getAdoptionAnalysisDetails?.adoptionAnalysisDetails?.map((ele) => {
      return ele?.providerId;
    });

  const getProviderValues = (providerIds) => {
    const arr = providerIds?.split(",")?.map((ele) => +ele);
    const res = TestPackageReducer?.getProviderListNetworkDetails?.filter(
      ({ providerId }) => arr?.includes(providerId)
    );
    const temp = res?.map((ele) => {
      return {
        value: ele?.providerId,
        label: ele?.providerId,
      };
    });
    return temp;
  };

  const downloadFile = () => {
    setIsLoadingExcel(true);
    const url = `${API_URL_WITHOUT_USER}/NetworkDashboard/ExportToExcelAdoptionAnalysisDetailsNetwork`;
    const data = {
      ...initialExcelStateAdoption,
      rows: selectAll ? 0 : searchFilter?.rows,
      providerIds: selectAll ? "" : multiSelect?.toString(),
      startDate: searchFilter?.startDate,
      endDate: searchFilter?.endDate,
      BusinessType: searchFilter?.BusinessType,
      VisitType: searchFilter?.VisitType,
      providerType:searchFilter?.providerType
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getToken(),
        MenuId: getNetworkMenuId()?.menuId,
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.blob())
      .then((blob) => {
        const filename = "AdoptionAnalysis.xlsx";
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setIsLoadingExcel(false);
      })
      .catch((error) => {
        console.error("Failed to fetch the file");
        setIsLoadingExcel(false);
      });
  };

  return (
    <div className="right-section" style={{ padding: "0px 20px",marginTop:"80px" }}>
      <div className="d-flex  flex-wrap" >
        {AdoptionFunnelBox?.map((ele, index) => {
          return (
            <div style={{width:"32%",marginRight:"10px"}} key={index}>
              <div className="servce_box">
                <div>
                  <img src={ele?.imgSrc} alt="exportsquare" />
                </div>
                <div>
                  <h3>
                    {getAdoptionAnalysisDetails?.[ele?.key]}
                    {ele?.percentSign && "%"}
                  </h3>
                  <p>{ele?.heading}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="card staff-details-section mt-3">
        <div className="card-body">
          <h4> Adoption Analysis </h4>
          <div className="row-filter">
            <Select
              className="basic-multi-select multiselect-search custom-width-300"
              style={{ width: "300px" }}
              classNamePrefix="select"
              placeholder="Search Provider Name or Code"
              name="colors"
              styles={{
                menu: (provided) => ({ ...provided, zIndex: 9999 }),
              }}
              options={TestPackageReducer?.getProviderListNetworkDetails?.map(
                (ele) => {
                  return {
                    value: ele?.providerId,
                    label: ele?.providerName,
                  };
                }
              )}
              isMulti
              closeMenuOnSelect={false}
              onChange={(e) => {
                setSearchFilter({
                  ...searchFilter,
                  ProviderIds: e?.map((ele) => ele.value)?.toString(),
                  providerName: e.map((e) => e.label).toString(),
                });
              }}
              value={getProviderValues(searchFilter?.ProviderIds)}
            />
            <select
              name="VisitType"
              
              className="white-form-select"
              value={
                searchFilter?.VisitType === null ? "" : searchFilter?.VisitType
              }
              onChange={(e) => {
                setSearchFilter({
                  ...searchFilter,
                  VisitType: e.target.value,
                });
              }}
            >
              <option value="">Select Visit Type</option>
              <option value="HV">Home Visit</option>
              <option value="CV"> Centre Visit</option>
            </select>
            <select
              name="BusinessType"
              style={{width:"210px"}}
              className="white-form-select"
              value={
                searchFilter?.BusinessType === null
                  ? ""
                  : searchFilter?.BusinessType
              }
              onChange={(e) => {
                setSearchFilter({
                  ...searchFilter,
                  BusinessType: e.target.value,
                });
              }}
            >
              <option value="">Select Business Type</option>
              <option value="IBU">IBU</option>
              <option value="CBU">CBU</option>
            </select>
            <select
              name="BusinessType"
              className="white-form-select"
              value={
                 searchFilter?.providerType
              }
              onChange={(e) => {
                setSearchFilter({
                  ...searchFilter,
                  providerType: e.target.value === "true" ? true : false,
                });
              }}
            >
              <option value={false}>All Provider</option>
              <option value={true}>Prime Centre</option>
            </select>
            <div className="dashbaord-date">
              <CommonDateRangePicker
                searchFilter={searchFilter}
                setSearchFilter={setSearchFilter}
                initialStartDate={new Date().setDate(new Date().getDate() - 1)}
                initialEndDate={new Date().setDate(new Date().getDate() - 1)}
              />
            </div>
            
          </div>
          <div className="row-results">
            <div className="d-flex gap-3">
              <select
                className="row-selectdropdown"
                value={searchFilter?.rows}
                onChange={(e) => {
                  setSearchFilter({
                    ...searchFilter,
                    page: 1,
                    rows: e.target.value,
                  });
                  dispatch(
                    getAdoptionAnalysisAction({
                      ...searchFilter,
                      rows: e.target.value,
                      page: 1,
                    })
                  );
                }}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
              </select>
              <p className="results">
                Total <span>{globalReducer?.getTotalCount}</span> results
              </p>
            </div>
            <div>
              {multiSelect?.length ? (
                <div className="select_all_div">
                  {!selectAll && (
                    <>
                      <p>{multiSelect?.length} providers are selected</p>
                      <span
                        className="select_all_primary_cases"
                        onClick={() => setSelectAll(true)}
                      >
                        Select all {globalReducer?.getTotalCount} providers
                      </span>
                    </>
                  )}
                  {selectAll && (
                    <p>{globalReducer?.getTotalCount} providers are selected</p>
                  )}
                </div>
              ) : null}
            </div>
            <div className="d-flex gap-3">
              <div className="search" type="button" onClick={handleSearch}>
                <a className="sidebar-links">
                  <SearchIcon />
                  <span className="sidebar-link-text">Search</span>
                </a>
              </div>
              <div className="search" type="button" onClick={handleClearFilter}>
                <a className="sidebar-links">
                  <span className="sidebar-link-text">Clear All</span>
                </a>
              </div>
              <button
                className={`btn ${
                  !isLoadingExcel ? "search__btn" : "disabled_btn"
                }`}
                type="button"
                onClick={!isLoadingExcel && downloadFile}
                disabled={!multiSelect?.length}
              >
                <i className="fa-solid fa-arrow-down"></i>&nbsp;
                {isLoadingExcel ? "Exporting..." : "Export To Excel"}
              </button>
            </div>
           
          </div>
          <div className="table-responsive __custom__properties">
            <table className="table">
              <thead>
                <tr className="avanishtbl">
                  <th>
                    <input
                      type="checkbox"
                      onClick={(e) =>
                        e?.target?.checked
                          ? (setSelectAll(false),
                            setMultiSelect([
                              ...new Set(
                                [
                                  ...multiSelect,
                                  ...getAdoptionAnalysisDetails?.adoptionAnalysisDetails?.map(
                                    (ele) => {
                                      return ele?.providerId;
                                    }
                                  ),
                                ].map((item) => item)
                              ),
                            ]))
                          : (setSelectAll(false),
                            setMultiSelect(
                              multiSelect?.length === 10
                                ? []
                                : multiSelect?.filter(
                                    (item) => !appointmentIds.includes(item)
                                  )
                            ))
                      }
                      checked={appointmentIds?.every((r) =>
                        multiSelect?.includes(r)
                      )}
                      className="form-check-input"
                      readOnly
                    />
                  </th>
                  {tableHeaderAnalysis?.map((ele, index) => {
                    return (
                      <TableHeaderAdmin
                        key={index}
                        header={ele?.name}
                        searchFilter={searchFilter}
                        SortHandler={SortHandler}
                      />
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {getAdoptionAnalysisDetails?.adoptionAnalysisDetails?.map(
                  (ele, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <input
                            type="checkbox"
                            onClick={(e) =>
                              e?.target?.checked
                                ? (setSelectAll(false),
                                  setMultiSelect([
                                    ...multiSelect,
                                    ele?.providerId,
                                  ]))
                                : (setSelectAll(false),
                                  setMultiSelect(
                                    multiSelect.filter(
                                      (value) => value !== ele?.providerId
                                    )
                                  ))
                            }
                            checked={multiSelect?.some(
                              (element) => element === ele?.providerId
                            )}
                            className="form-check-input"
                            readOnly
                          />
                        </td>
                        <td> {ele?.providerId}</td>
                        <td> {ele?.providerName} </td>
                        <td> {ele?.totalAppointment}</td>
                        <td> {ele?.acceptReject}% </td>
                        <td> {ele?.showNoShow}% </td>
                        <td> {ele?.reportUpload}% </td>
                        <td> {ele?.reportOnHold}% </td>
                      </tr>
                    );
                  }
                )}
              </tbody>
            </table>
          </div>
          <div className="pagination-row">
            {globalReducer?.getTotalCount !== 0 && (
              <CustomPagination
                totalCount={globalReducer?.getTotalCount}
                perPageData={searchFilter?.rows}
                searchFilter={searchFilter}
                setSearchFilter={setSearchFilter}
                apiCall={getAdoptionAnalysisAction}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdoptionAnalysis;
